import {
  TableBodyCellContainer,
  TableHeadCellContainer,
} from 'app/styles/components/Table';
import { BusinessEditSideSheet } from '../../../../components/BusinessEditSideSheet';
import { TScrDetailItem } from 'modules/customer/interfaces/scr';
import { Table, TextL, TextS } from 'app/components';
import { formatCurrency } from 'app/utils/normalizer';

export interface ILegalPersonViewScrDetailsSideSheet {
  itemDetail: TScrDetailItem | null;
  handleClose: () => void;
  isOpen: boolean;
}

const tableHeader = [
  {
    id: '1',
    content: (
      <TableHeadCellContainer>
        <TextL weight="bold">Descrição</TextL>
      </TableHeadCellContainer>
    ),
  },
  {
    id: '2',
    content: (
      <TableHeadCellContainer>
        <TextL weight="bold">Valor</TextL>
      </TableHeadCellContainer>
    ),
  },
];

const LegalPersonViewScrDetailsSideSheet = ({
  itemDetail,
  handleClose,
  isOpen,
}: ILegalPersonViewScrDetailsSideSheet) => {
  const onClose = () => {
    handleClose();
  };

  return (
    <BusinessEditSideSheet
      open={isOpen}
      handleClose={onClose}
      title="Vencimentos"
      showBackdrop={true}
      isCloseButtonDisabled={true}
    >
      {itemDetail && (
        <Table
          tableHeadCell={tableHeader}
          maxBodyHeight="90vh"
          tableBodyContent={itemDetail.vencimentos.map((item, index) => {
            return {
              id: `${item.categoria}-${String(index)}`,
              cells: [
                {
                  id: '1',
                  content: (
                    <TableBodyCellContainer>
                      <TextS>{item.descricao ?? '-'}</TextS>
                    </TableBodyCellContainer>
                  ),
                },
                {
                  id: '2',
                  content: (
                    <TableBodyCellContainer>
                      <TextS>
                        {itemDetail.valor
                          ? formatCurrency(parseFloat(item.valor))
                          : '-'}
                      </TextS>
                    </TableBodyCellContainer>
                  ),
                },
              ],
            };
          })}
        />
      )}
    </BusinessEditSideSheet>
  );
};

export default LegalPersonViewScrDetailsSideSheet;
